import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=2cf0ca1d&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "./Result.vue?vue&type=style&index=0&id=2cf0ca1d&lang=stylus&scoped=true&"
import style1 from "./Result.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf0ca1d",
  null
  
)

export default component.exports